import { app } from "../api";
import { useQuery, useMutation, useQueryCache } from "react-query";

export async function getUserInfo(userId: string) {
  const userData = await app.firestore().collection("users").doc(userId).get();
  const res = userData.data();
  return res;
}

export function useUserInfo(userId: string) {
  return useQuery([`users`, userId], () => {
    return getUserInfo(userId);
  });
}

// returns a list of pending discount cards for a lab
export function getPendingFamilyCards(uid: string) {
  const pendingCards = app
    .firestore()
    .collectionGroup("familyCards")
    .where("labId", "==", uid)
    .where("status", "==", "pending")
    .get()
    .then((familyCards) => familyCards.docs.map((i) => i.data()));
  return pendingCards;
}
export function usePendingFamilyCards() {
  return useQuery(["familyCards"], getAllLabFamilyCardWithUserInfo);
}
export async function getAllLabFamilyCardWithUserInfo() {
  const uid = app.auth().currentUser?.uid;

  let query = app
    .firestore()
    .collectionGroup("familyCards")
    .where("labId", "==", uid);
  // .where("status", "==", "pending");

  const familyCards = await query
    .get()
    .then((familyCardsRef) => familyCardsRef.docs.map((i) => i.data()));

  const userIds = Array.from(new Set(familyCards.map((i) => i.userId)));
  const promises = userIds.map((userId: string) =>
    app
      .firestore()
      .collection("users")
      .doc(userId)
      .get()
      .then((res) => res.data())
  );
  const users = await Promise.all(promises);
  return familyCards.map((familyCard) => {
    familyCard["user"] = users.find((user) => user?.id === familyCard.userId);
    return familyCard;
  });
}

export function useFamilyCard(id: string) {
  return useQuery(["familyCard", id], async () => {
    try {
      let familyCardRef = await app
        .firestore()
        .collectionGroup("familyCards")
        .where("id", "==", id)
        .get();
      let familyCard = familyCardRef.docs[0].data();
      let user = (
        await app.firestore().collection("users").doc(familyCard.userId).get()
      ).data();
      return { familyCard, user };
    } catch (e) {
      console.error(e);
      return null;
    }
  });
}

export function useUpdateFamilyCard() {
  const queryCache = useQueryCache();
  return useMutation((data: any) => updateFamilyCard(data), {
    onSuccess: () => {
      queryCache.invalidateQueries("familyCards");
      queryCache.invalidateQueries(["familyCard"]);
    },
  });
}

export async function updateFamilyCard(familyCard: any) {
  const res = app
    .firestore()
    .collection("users")
    .doc(familyCard.userId)
    .collection("familyCards")
    .doc(familyCard.id);
  await res.update(familyCard);
  return familyCard;
}
